<template>
    <span>{{ formatted }}</span>
</template>

<script>
    export default {
        name: "DateFormatted",
        props: {
            date: {
                type: Date,
                required: true
            }
        },
        computed: {
            formatted() {
                return this.appendLeadingZeroes(this.date.getDate())
                    + "/" + this.appendLeadingZeroes(this.date.getMonth() + 1)
                    + "/" + this.date.getFullYear();
            }
        },
        methods: {
            appendLeadingZeroes(n) {
                if (n <= 9) {
                    return "0" + n;
                }
                return n
            }
        }
    }
</script>

<style scoped>

</style>